import {Component, Input, OnInit} from '@angular/core';
import {EntityConfig, RestUrlsConfig} from '@signature-it/ngx-generic/config';
import {ShareDataService} from '@signature-it/ngx-generic/services';
import {EntityService, SolrEntityService, EntityPageService} from "@signature-it/ngx-entity/services";
import {PageRelatedMediaPreviewEntityConfig, SolrOptionsEntityDTO} from "@signature-it/ngx-entity/models";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import * as EntitySelectors from '@signature-it/ngx-entity/store/selectors';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';

declare let _ : any;

@Component({
    selector: 'page-related-media-preview',
    templateUrl: './page-related-media-preview.component.html',
    styleUrls: ['./page-related-media-preview.component.scss'],
    standalone: false
})
export class PageRelatedMediaPreviewComponent implements OnInit {
    @Input() key: number;
    @Input() additionalQuery: string;
    @Input() mediaIds: string;
    items: any = [];
    pageData: PageRelatedMediaPreviewEntityConfig;
    gridInfo = {};
    entity;
    templates;
    templates$: Observable<any>;
    loadingTpl$: Observable<boolean>;

     constructor( public entityService: EntityService,
                  protected solrEntityService: SolrEntityService,
                  public sharedSvc: ShareDataService,
                  public restUrlsConf: RestUrlsConfig,
                  protected entityPageService: EntityPageService,
                  protected store$: Store<any>) {
         this.templates$ = this.store$.select(EntitySelectors.getPreviews);
         this.loadingTpl$ = this.store$.select(EntitySelectors.getIsLoadingPreviews);
     }

     ngOnInit() {
         this.store$.dispatch(EntityActions.getPreviews());
         this.pageData = PageRelatedMediaPreviewEntityConfig.create(EntityConfig.ngxPageRelatedMediaPreview[this.key]);
         this.entity = this.entityPageService.mainEntity;
         this.setGridInfo();
         let relatedItemsVar;
         if (this.mediaIds) {
             relatedItemsVar = this.mediaIds.split(',');
         } else if(this.entity && this.pageData.relatedItemSolrKey) {
             relatedItemsVar = this.entity[this.pageData.relatedItemSolrKey];
         }
         if(relatedItemsVar) {
             this.solrEntityService.getSolrMediaByIdList(relatedItemsVar).subscribe(items => {
                 const response = items['response']['docs'].map(item => {
                     item['download_url'] = `${this.restUrlsConf.appURL}/public/download/media/${+item['media_id_i']}.json`;
                     return item;
                 });

                 relatedItemsVar.forEach(relatedId => {
                     const found = response.find(item => item['media_id_i'] == relatedId);
                     if(found)
                        this.items.push(found);
                 });
             })
         } else if(this.additionalQuery) {
             let solrOptions = new SolrOptionsEntityDTO({
                 extraQryString:  this.additionalQuery,
             });
            this.solrEntityService.getSolr(solrOptions).subscribe(res => {
                 this.items = res['response']['docs'].map(item => {
                     item['download_url'] = `${this.restUrlsConf.appURL}/public/download/media/${+item['media_id_i']}.json`;
                     return item;
                 });
            })
         }
     }

    setGridInfo() {
        let responsiveKeys = _.keys(this.pageData.responsive);
        const currentKey = this.sharedSvc.getCurrentBp(responsiveKeys);
        this.gridInfo =  this.pageData.responsive[currentKey] || {};
    }
}
